import React from 'react';

export const FilledFile: React.FC<React.HTMLAttributes<SVGElement>> = (props) => (
    <svg viewBox='0 0 16 16' {...props}>
      <g transform='translate(1)'>
        <path
          fill='currentColor'
          d='M77.97,4.206a.319.319,0,0,0-.085-.109L73.22.1a.413.413,0,0,0-.127-.073A.449.449,0,0,0,72.944,0H65.167A1.094,1.094,0,0,0,64,1V15a1.094,1.094,0,0,0,1.167,1H76.833A1.094,1.094,0,0,0,78,15V4.333A.3.3,0,0,0,77.97,4.206ZM74.5,12h-7a.337.337,0,1,1,0-.667h7a.337.337,0,1,1,0,.667Zm0-2.667h-7a.337.337,0,1,1,0-.667h7a.337.337,0,1,1,0,.667Zm0-2.667h-7A.337.337,0,1,1,67.5,6h7a.337.337,0,1,1,0,.667ZM73.722,4a.365.365,0,0,1-.389-.333V1.138L76.672,4Z'
          transform='translate(-64)' />
      </g>
    </svg>
  )
;
